/// <amd-module name="VSS/Redux/Modules/Navigation/NavigationSaga" />
import { effects, SagaIterator } from "redux-saga";
import { ActionsOfType } from "redux/Utils/ActionHelper";
import { NavigationActions, NavigationActionTypes } from "VSS/Redux/Modules/Navigation/NavigationActions";
import { FastPageSwitch } from 'VSS/Platform/FPS';
import { IVssPageContext } from 'VSS/Platform/Context'

export function* navigationSaga(): SagaIterator {
    yield effects.takeLatest(NavigationActionTypes.FPSNavigateToUrl, fpsNavigateToUrl);
}

export function* fpsNavigateToUrl(action: ActionsOfType<NavigationActions, NavigationActionTypes.FPSNavigateToUrl>): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    yield effects.call(FastPageSwitch, pageContext, action.payload.url, action.payload.recordHistoryEntry);
}
